

















import { Component, Prop, Watch, Vue} from 'vue-property-decorator';
import * as dayjs from 'dayjs';
import VueApexCharts from 'vue-apexcharts';
import HeatmapService from '../services/HeatmapService';
Vue.use(VueApexCharts);
Vue.component('apexchart', VueApexCharts);

@Component
export default class CountChart extends Vue {

    public init: boolean = false;

    public chartOptions: any = {
        chart: {
            id: 'counts-barchart',
            width: '100%',
            height: 500,
        },
        fill: {
            colors: ['#0d47a1'],
        },
        xaxis: {
            categories: [],
        },
    };

    public series: any = [{
        name: 'Lockbox Transactions',
        data: [],
    }];

    public debounce: boolean = false;

    get startDate() {
        return this.$store.state.heatmap.startDate;
    }

    get endDate() {
        return this.$store.state.heatmap.endDate;
    }

    get showChart() {
        return this.$store.state.heatmap.showChart;
    }

    get map() {
        return this.$store.state.map;
    }

    get mapView() {
        return this.$store.state.mapView;
    }

    get dateCounts() {
        return this.$store.state.heatmap.dateCounts;
    }

    public unsubscribe = this.$store.subscribeAction((action, state) => {
        // if (action.type === 'updateEndDate') {
        //     this.updateCountData();
        // }
    });

    @Watch('showChart', { immediate: false, deep: false })
    public showChartChanged(value: boolean, oldValue: boolean) {
        if (value) {
            this.updateCountData();
        }
    }

    @Watch('dateCounts', { immediate: false, deep: false })
    public dateCountsChange(value: boolean, oldValue: boolean) {
        if (this.showChart) {
            this.updateCountData();
        }
    }

    public toggleShow() {
        this.$store.dispatch('toggleChart');
    }

    public updateCountData() {
        console.log('CountHeatmapChart: updateCountData()');
        if (this.dateCounts.length > 0) {
            const newXAxis: any = [];
            const newData: any = [];
            this.dateCounts.forEach((element: any) => {
                newXAxis.push(element.date.replace('T00:00:00', ''));
                newData.push(element.count);
            });
            this.chartOptions = {
                chart: {
                    id: 'counts-barchart',
                },
                xaxis: {
                    categories: newXAxis,
                },
            };
            this.series = [{
                name: 'Lockbox Transactions',
                data: newData,
            }];
        }
    }


    public mounted() {
        console.log('CountChart: mounted()');
    }

    public beforeDestroy() {
        console.log('CountChart: beforeDestroy()');
        this.unsubscribe();
    }


}

